<template>
  <div class="text-center" style="padding: 72px;">
    <div style="font-weight: 700; font-size: 36px; padding-bottom: 24px;">
      {{ t('Are you still there?') }}
    </div>
    <div style="font-weight: 400; font-size: 36px; padding-bottom: 48px;">
      {{ t('Please confirm you are still shopping') }}
    </div>
    <div>
      <div>
        <v-btn
          class="text-none"
          color="accent"
          height="120"
          variant="text"
          block
          @click="reset"
          @touchend="reset"
        >
          <div style="font-weight: 700; font-size: 36px;">
            {{ t('Start over') }}
          </div>
        </v-btn>
      </div>
      <div>
        <v-btn
          class="text-none bg-primary"
          height="120"
          variant="flat"
          block
          @click="confirm"
          @touchend="confirm"
        >
          <div style="font-weight: 700; font-size: 36px;">
            {{ t('Continue shopping') }}
          </div>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useStore } from "../../stores/store";

export default {
  name: "ConfirmActivity",
  setup() {
    const store = useStore()
    const { t, te } = useI18n()

    return {
      store,
      t,
      te
    }
  },
	data() {
		return {
			processing: false,
			autoResetTimeoutId: null
		}
	},
  mounted() {
    this.autoResetTimeoutId = setTimeout(() => {
      this.reset()
    }, 30000)
  },
  beforeUnmount() {
    this.clearAutoReset()
  },
  methods: {
    clearAutoReset() {
      if(this.autoResetTimeoutId !== null) {
        clearTimeout(this.autoResetTimeoutId)
        this.autoResetTimeoutId = null
      }
    },
    reset() {
      if(this.processing === true) {
        return
      }
      this.clearAutoReset()
      this.processing = true
      setTimeout(() => {
        this.$emit('reset')
        this.processing = false
      }, 100)
    },
    confirm() {
      if(this.processing === true) {
        return
      }
      this.clearAutoReset()
      this.processing = true
      setTimeout(() => {
        this.$emit('confirm')
        this.processing = false
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>